// utils/errors.js
export function getUserError(t, actionKey, err, { revealStatusCode = false } = {}) {
  const map = { approve: "Approve", reject: "Reject", edit: "Edit", create: "Create", save: "Create" };
  const norm = map[String(actionKey).toLowerCase()] || actionKey;

  const gerund = t(`verbsGerund.${String(norm).toLowerCase()}`, {
    defaultValue: `${String(norm).toLowerCase()}ing`,
  });

  const status = err?.status ?? err?.response?.status;
  const contact = t("errorsRecommendation.contact", {
    defaultValue: "the system administrator",
  });

  if (err?.status === 0 || (!err?.response && err?.message === "Network Error")) {
    return t("errorsRecommendation.network", {
      action: gerund,
      defaultValue: `Network error while ${gerund} recommendation. Check your connection.`,
    });
  }

  let msg = t("genericServer", {
    defaultValue: "An unexpected server error occurred.",
  });

  if (revealStatusCode && status) {
    msg += ` (code ${status}).`;
  }

  return t("errorsRecommendation.actionFailed", {
    action: gerund,
    msg,
    contact,
  });
}
